import { bool, func, any, string } from "prop-types";
import React, { useCallback, useState, useRef } from "react";
import { twMerge } from "tailwind-merge";

import Modal from "@components/shared/Modal";
import { Button } from "@components/shared/Button";
import ButtonGroup from "@components/shared/ButtonGroup";
import { useIsScrolledToBottom } from "../../hooks/useIsScrolledToBottom";

const Popin = ({
  isOpen,
  onClose,
  onConfirm,
  confirmTitle,
  children,
  title,
  preventConfirmBeforeScroll = false,
  ...props
}) => {
  const [containerNode, setContainerNode] = useState(null);
  const initContainerNode = useCallback(node => setContainerNode(node), [
    setContainerNode,
  ]);

  const modalLastElement = useRef(null);

  const isScrolledToBottom = useIsScrolledToBottom(containerNode, {
    disabled: !preventConfirmBeforeScroll,
  });

  return (
    <Modal
      isOpen={isOpen}
      ariaLabel={title ?? ""}
      onClose={onClose}
      {...(modalLastElement ? { lastElement: modalLastElement } : {})}
      {...props}
    >
      <div className="grid grid-rows-[auto_1fr_auto] grid-cols-1 gap-4 max-h-[calc(100svh-2rem-4px)] sm:max-h-[calc(80svh-2rem-4px)] sm:px-4">
        <h4 className="text-xl font-semibold">{title}</h4>
        <div
          className={twMerge(
            "overflow-auto relative fancy-scrollbars h-",
            containerNode &&
              containerNode.scrollHeight > containerNode.clientHeight &&
              "pr-2"
          )}
          ref={initContainerNode}
        >
          {children}
        </div>
        {onConfirm && confirmTitle && (
          <ButtonGroup className="!flex-col">
            <Button
              data-id="home-ami-pop-in-confirmation-button"
              disabled={preventConfirmBeforeScroll && !isScrolledToBottom}
              onClick={onConfirm}
              ref={modalLastElement}
            >
              {confirmTitle}
            </Button>
          </ButtonGroup>
        )}
      </div>
    </Modal>
  );
};

Popin.propTypes = {
  isOpen: bool.isRequired,
  onClose: func.isRequired,
  onConfirm: func,
  children: any.isRequired,
  confirmTitle: string,
  title: string.isRequired,
  overlayColor: string,
  preventConfirmBeforeScroll: bool,
};

export default Popin;
